import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class FaxService {
  /**
   * Base URL for controller
   * @type {string}
   */
  private url: string = 'faxes';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Index page with recent faxes
   * @param  {any       = {}}        params Search params
   * @return {Promise<any>}   Server response
   */
  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  /**
   * Fax show page info
   * @param  {number}       id Id of fax
   * @return {Promise<any>}    Server response
   */
  show(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}.json`);
  }
}
